import React, { useEffect, useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import ButtonPrimary from "../../../components/button/ButtonPrimary";
import axios from "axios";
import CustomLoader from "../../../components/loader";

import {
  setArticleDataCitation,
  setCitationData,
  setCitationPopup,
  setUrl,
} from "../../../redux/features/dataSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  citationDate,
  getFormattedDate,
  getRegularDate,
} from "../../../functions/time";
import { Tooltip } from "@mui/material";
import { toast } from "react-toastify";
import { citationAPI, getConfig, searchAPI } from "../../../apis";

import Draggable from "react-draggable";
import { useIsMobile } from "../../../functions/isMobile";
import DateComponent from "../../../components/DateComponent";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { mapCitationData } from "../../../constants";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import MenuPrimary from "../../../components/menu/MenuPrimary";
import { useLocation } from "react-router-dom";
import { axiosInstance } from "../../../functions/axios";
import useDocumentTypes from "../../../hooks/useDocumentTypes";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

const FIELDS = {
  title: "Title",
  author: "Author",
  section: "Section",
  date: "Date",
  url: "URL",
  accessDate: "Accessed",
  language: "Language",
  publicationTitle: "Publication",
  ISSN: "ISSN",
  pages: "Pages",
  edition: "Edition",
};

const PopupCitation = (props) => {
  const isMobile = useIsMobile();
  const [authors, setAuthors] = useState([
    { firstName: "", lastName: "", creatorType: "author" },
  ]);

  const [loading, setLoading] = useState(true);
  const [citationStyles, setCitationStyles] = useState({});
  const [selectedStyle, setSelectedStyle] = useState({});
  const [currentStyle, setCurrentStyle] = useState({});
  const [requiredFields, setRequiredFields] = useState({});
  const [error, setError] = useState(null);
  const [changeTooltip, setChangeTooltip] = useState(false);
  const [editingValue, setEditingValue] = useState("");
  const [editingField, setEditing] = useState(null);
  const [fieldChecks, setFieldChecks] = useState(false);
  const [citationFields, setCitationFields] = useState({});
  const [options, setOptions] = useState({});
  const [currentItemType, setCurrentItemType] = useState({
    name: "webpage",
    key: "webpage",
  });
  const [additionalData, setAdditionalData] = useState({});
  const [baseFields, setBaseFields] = useState({});

  const {
    collectionIdid,
    citationAvailable,
    setSaveBookmarkPopup,
    setBookmarkData,
    articleData,
    setArticleData,
    citation,
    setCitation,
    handleSavedCollection,
  } = props;
  const { citationPopup, url, summaryInfoData, itemTypes } = useSelector(
    (state) => state.data
  );
  const { user } = useSelector((state) => state.auth);
  useDocumentTypes(user.userId);
  const [calendarPopup, setCalendarPopup] = useState(false);
  const [date, setDate] = useState(null);
  const [accessDate, setAccessDate] = useState(null);
  const [currVal, setCurrVal] = useState("");
  const [savedStyle, setSavedStyle] = useState("");
  const location = useLocation();
  const dispatch = useDispatch();
  const [position, setPosition] = useState({
    marginTop: 0,
    marginLeft: 0,
  });

  const handleCopy = () => {
    const textToCopy = citation;
    const html = new Blob([textToCopy], { type: "text/html" });
    const plain = new Blob([textToCopy.replace(/<[^>]*>?/gm, "")], {
      type: "text/plain",
    });

    navigator.clipboard
      .write([
        new ClipboardItem({
          "text/html": html,
          "text/plain": plain,
        }),
      ])
      .then(() => {
        console.log("Content copied");
        setChangeTooltip(true);
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  const getFields = async ({ switchIndex = 0, dataInd }) => {
    try {
      const { data } = await axiosInstance.post(
        searchAPI.GetCitationDynamicData,
        {
          user: user.userId,
          itemTypeId: !switchIndex ? currentItemType.id : dataInd.id,
        }
      );
      let baseFields = {},
        requiredFields = [];
      const response = data[0].dynamicFields.reduce((acc, item) => {
        acc[item.fieldName_chr] = item.displayFieldName_chr;
        if (item.baseFieldName_chr) {
          baseFields[item.fieldName_chr] = item.baseFieldName_chr;
        }
        if (item.isRequired_ysn) {
          requiredFields.push(item.fieldName_chr);
        }
        return acc;
      }, {});

      const authors = data[0].creators.reduce((acc, item) => {
        if (item.isDefault_ysn) {
          if (item.creatorName_chr === "author") {
            acc["creators"] = "Author";
          } else {
            acc[item.creatorName_chr] = item.displayName_chr;
          }
        }
        if (item.isRequired_ysn) {
          if (item.creatorName_chr === "author") {
            requiredFields.push("creators");
          } else requiredFields.push(item.creatorName_chr);
        }
        return acc;
      }, {});

      if (Object.keys(response).length === 0) {
        setCitationFields(FIELDS);
        return;
      }
      setCitationFields({
        ...authors,
        ...response,
      });
      setRequiredFields(requiredFields);

      return {
        fields: { ...response, ...authors },
        baseFields: baseFields,
      };
    } catch (e) {
      console.log(e);
    }
  };

  const mapArticleData = (res, fields) => {
    let newArticleData = {},
      additionalData = {};
    newArticleData = resetArticleData(
      newArticleData,
      fields.fields,
      res,
      fields.baseFields
    );
    additionalData = resetAdditionalData(newArticleData, fields, res);
    setArticleData(newArticleData);
    setAdditionalData(additionalData);
  };

  async function mapBackendToFrontend(data, currentItemType) {
    const res = mapCitationData(data);
    const fields = await getFields({
      switchIndex: 1,
      dataInd: currentItemType,
    });
    mapArticleData(res, fields);
    return res;
  }

  function getValidDate(dateString) {
    if (!dateString) return null;
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return null;
    } else {
      return date;
    }
  }

  function getCitationDate(dateString) {
    if (!dateString) return null;
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return null;
    } else {
      return new Date(date);
    }
  }

  const fetchIfExistingCitation = async () => {
    try {
      const { data } = await axiosInstance.post(
        searchAPI.getCitation,
        {
          collectionSourceId: collectionIdid,
          userId: user.userId,
        },
        getConfig()
      );
      if (data[0].creators) {
        const authors = data[0].creators.map((author) => {
          return {
            firstName: author.firstName_chr,
            lastName: author.lastName_chr,
            creatorType: "author",
            citationCreatorId: author.citationCreatorId_ids,
          };
        });
        data[0].creators = authors;
        setAuthors(authors);
      }
      const currentItemType = itemTypes.filter(
        (item) => item.key.toLowerCase() === data[0].itemType_chr.toLowerCase()
      )[0];
      setCurrentItemType(currentItemType);
      setSavedStyle(data[0].styles_chr);

      setCitation(data[0].citation_chr);
      await mapBackendToFrontend(data[0], currentItemType);
      setDate(getValidDate(data[0].date_dtm));
      setAccessDate(getValidDate(data[0].accessDate_dtm));
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const format_response = (data) => {
    const creators = data[0].creators || [];

    setArticleData((prev) => {
      const newState = {
        ...prev,
        ...data[0],
        date: getValidDate(data[0].date),
        accessDate: getValidDate(data[0].accessDate),
      };
      return newState;
    });
  };

  const handleExternalArticleBaseFieldsData = (data, baseFields) => {
    const tempExternalData = {
      title: summaryInfoData.title,
      url: summaryInfoData.url,
      publicationTitle: summaryInfoData.publisher,
      data: summaryInfoData.published_date,
    };

    for (const key in baseFields) {
      const mappedField = baseFields[key];
      console.log(key, mappedField);

      if (tempExternalData[mappedField] && !data[0][key]) {
        data[0][key] = tempExternalData[mappedField];
      }
    }

    return data;
  };

  const handleExternalArticleData = (data, fields) => {
    if (summaryInfoData.title && fields.title) {
      if (!data[0]?.title)
        data[0] = {
          ...data[0],
          title: summaryInfoData.title,
        };
    }
    if (summaryInfoData.url && fields.url) {
      data[0] = {
        ...data[0],
        url: summaryInfoData.url,
      };
    }
    if (summaryInfoData.publisher && fields.publicationTitle) {
      data[0] = {
        ...data[0],
        publicationTitle: summaryInfoData.publisher,
      };
    }
    return data;
  };

  const handleArticleDates = (data, fields) => {
    if (summaryInfoData.published_date && fields.date) {
      setDate(getValidDate(summaryInfoData.published_date));
      data[0] = {
        ...data[0],
        date: getValidDate(summaryInfoData.published_date),
      };
    } else {
      if (getValidDate(data[0].date)) {
        setDate(getValidDate(data[0].date));
      } else {
        setDate(null);
      }
    }
    setAccessDate(getValidDate(data[0].date));
  };

  const handleEmptyDataFields = (data, fields) => {
    if (!data.length || typeof data[0] !== "object" || data[0] === null) {
      data[0] = { itemType: "webpage", styles: "apa" };
    }

    Object.keys(fields).forEach((field) => {
      if (!(field in data[0]) || !data[0][field]) {
        data[0][field] = field.toLocaleLowerCase().includes("date") ? null : "";
      }
    });

    return data;
  };

  const handleSuccessCitationResponse = async (data, currentItemType) => {
    let fields = await getFields({ switchIndex: 1, dataInd: currentItemType });
    setBaseFields(fields.baseFields);

    data = handleEmptyDataFields(data, fields.fields);
    data = handleExternalArticleData(data, fields.fields);
    data = handleExternalArticleBaseFieldsData(data, fields.baseFields);
    handleArticleDates(data, fields.fields);

    format_response(data);
  };

  const handleErrorCitationResponse = async () => {
    let fields = await getFields({ switchIndex: 1, dataInd: itemTypes[1] });
    setBaseFields(fields.baseFields);
    let data = {};
    data = handleEmptyDataFields(data, fields.fields);
    data = handleExternalArticleData(data, fields.fields);
    data = handleExternalArticleBaseFieldsData(data, fields.baseFields);
    handleArticleDates(data, fields.fields);
    setArticleData(data[0]);
  };

  const fetchCitation = async () => {
    const anyFieldMissing = requiredFields.some((field) => {
      if (field === "creators") {
        return Boolean(!authors[0]?.firstName);
      } else {
        return !articleData[field];
      }
    });
    if (anyFieldMissing) {
      console.log(requiredFields);
      toast.error("Please fill in all required fields.");
      return;
    }
    setLoading(true);

    let config = {
      method: "post",
      url: `${citationAPI.getCitation}?responseformat=html&style=${currentStyle.key}`,
      data: {
        items: [
          {
            itemType: articleData.itemType ? articleData.itemType : "webpage",
            key: articleData.key ? articleData.key : "VH$KV",
            ...articleData,
            creators: authors,
            editingField: editingValue,
          },
        ],
      },
    };
    try {
      const { data } = await axios.request(config);
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, "text/html");
      const entryElement = doc.querySelector(".csl-entry");

      if (entryElement) {
        const citationHTML = entryElement.innerHTML;
        setCitation(citationHTML);
        dispatch(setCitationData(citationHTML));
      }
    } catch (err) {
      setError(err.toString());
      toast.error(
        "Some error occured while generating citation. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const generateCitationData = async () => {
    fetchCitation();
    handleFieldChecks();
  };

  const setDefaultForFields = (fieldVals, reqKey) => {
    setArticleData((prev) => {
      const updatedData = { ...prev };

      for (const key of fieldVals[reqKey]) {
        if (!prev[key]) {
          if (key.includes("date")) {
            updatedData[key] = null;
          } else {
            updatedData[key] = "";
          }
        }
      }
      return updatedData;
    });
  };

  const fetchStyles = async () => {
    try {
      const { data } = await axios.get(citationAPI.getCitationStyles);
      setCitationStyles(data);
      setSelectedStyle(data[0].name);
      const opts = data.map((style) => ({
        name: style.title,
        key: style.name,
      }));
      setOptions(opts);
      if (!collectionIdid || !citationAvailable) setCurrentStyle(opts[0]);
      setArticleData((prev) => ({ ...prev, styles: data[0].name }));
    } catch (err) {
      setError(err.toString());
    }
  };

  const handleMouseOut = (event) => {
    setTimeout(() => {
      const fromElement = event.relatedTarget;
      const tooltipButton = document.getElementById("tooltipButton");

      if (!tooltipButton.contains(fromElement)) {
        setChangeTooltip(false);
      }
    }, 1000);
  };

  const handleNull = () => {
    setCitation("");
    setCitationFields({});
    dispatch(setArticleDataCitation({}));
  };

  const handleClose = () => {
    setCurrentStyle("");
    setCitation("");
    setArticleData({});
    setBookmarkData({});
    dispatch(setUrl(""));
    dispatch(setCitationPopup(false));
  };

  const handleChange = (e) => {
    const selectedStyle = options.filter((option) => option.name === e);
    const citationCurrentStyle = selectedStyle[0];
    setCurrentStyle(citationCurrentStyle);

    setSelectedStyle(citationCurrentStyle.key);
    setArticleData((prev) => ({
      ...prev,
      styles: citationCurrentStyle.name,
    }));
  };

  const checkBaseField = (newBaseFields, field) => {
    return (
      newBaseFields[field] && findBaseFieldKeyByValue(newBaseFields[field])
    );
  };

  const findBaseFieldKeyByValue = (valueToFind) => {
    const baseFieldKey = Object.keys(baseFields).find(
      (key) => baseFields[key] === valueToFind
    );
    return baseFieldKey;
  };

  const getBaseFieldVal = (newBaseFields, field) => {
    const baseFieldKey = findBaseFieldKeyByValue(newBaseFields[field]);

    if (articleData[baseFieldKey]) {
      return articleData[baseFieldKey];
    }
    return additionalData[newBaseFields[field]];
  };

  const resetArticleData = (
    newArticleData,
    fields,
    articleData,
    newBaseFields
  ) => {
    Object.keys(fields).forEach((field) => {
      if (articleData.hasOwnProperty(field)) {
        newArticleData[field] = articleData[field];
      } else if (checkBaseField(newBaseFields, field)) {
        newArticleData[field] = getBaseFieldVal(newBaseFields, field);
        additionalData[newBaseFields[field]] = newArticleData[field];
      } else if (additionalData.hasOwnProperty(field)) {
        newArticleData[field] = additionalData[field];
      } else if (articleData.hasOwnProperty(newBaseFields[field])) {
        newArticleData[field] = articleData[newBaseFields[field]];
      } else if (additionalData.hasOwnProperty(newBaseFields[field])) {
        newArticleData[field] = additionalData[newBaseFields[field]];
      } else {
        newArticleData[field] = field === "creators" ? {} : "";
      }
    });

    const baseFieldArr = Object.values(baseFields);
    Object.keys(fields).forEach((field) => {
      if (baseFieldArr.includes(field)) {
        const baseKey = Object.keys(baseFields).find(
          (key) => baseFields[key] === field
        );
        newArticleData[field] = articleData[baseKey];
      }
    });
    setBaseFields(newBaseFields);
    return newArticleData;
  };

  const resetAdditionalData = (newArticleData, fields, articleData) => {
    let newAdditionalData = { ...additionalData };
    Object.keys(articleData).forEach((key) => {
      if (!fields.hasOwnProperty(key) && !newArticleData.hasOwnProperty(key)) {
        newAdditionalData[key] = articleData[key];
      }
    });

    return newAdditionalData;
  };

  const handleItemChange = async (e) => {
    setCurrentItemType(e);
    setLoading(true);

    let newArticleData = { itemType: e.key };
    const fields = await getFields({ switchIndex: 1, dataInd: e });

    newArticleData = resetArticleData(
      newArticleData,
      fields.fields,
      articleData,
      fields.baseFields
    );

    const newAdditionalData = resetAdditionalData(
      newArticleData,
      fields.fields,
      articleData
    );

    setArticleData(newArticleData);
    setAdditionalData(newAdditionalData);

    setLoading(false);
  };

  const tooltipTitle = changeTooltip
    ? "Copied to clipboard"
    : "Copy to clipboard";

  const renderFieldValue = (field) => {
    if (editingField === field) {
      return editingValue;
    } else
      switch (field) {
        case "date":
          return getRegularDate(articleData[field]);
        case "accessDate":
          return getRegularDate(articleData[field]);
        default:
          return articleData[field];
      }
  };

  const handleFieldChecks = () => {
    const allFieldsPresent = requiredFields?.every(
      (field) => articleData[field] != null
    );
    setFieldChecks(allFieldsPresent);
  };

  const isValidDate = (d) => {
    if (Object.prototype.toString.call(d) === "[object Date]") {
      if (isNaN(d.getTime())) return false;
      else return true;
    }
    return false;
  };

  const handleInputChange = (field, value) => {
    setEditingValue(value);
  };

  const addAuthor = (position) => {
    const newAuthor = {
      firstName: "",
      lastName: "",
      creatorType: "author",
    };

    setAuthors([
      ...authors.slice(0, position),
      newAuthor,
      ...authors.slice(position),
    ]);
  };

  const removeAuthor = (index) => {
    const newAuthors = [...authors];
    newAuthors.splice(index, 1);
    setAuthors(newAuthors);
    setArticleData((prevData) => ({ ...prevData, creators: newAuthors }));
  };

  const handleAuthorChange = (index, field, value) => {
    const newAuthors = [...authors];
    newAuthors[index][field] = value;
    setAuthors(newAuthors);
  };

  const renderEditableField = (field) => {
    const value =
      editingField === field ? editingValue : renderFieldValue(field);
    const required = requiredFields?.includes(field) && !isNaN(value);

    const handleBlur = () => {
      setEditing(null);
      if (field === "author") {
      } else if (["date", "accessDate"].includes(field)) {
        if (isValidDate(new Date(editingValue))) {
          setArticleData((prevData) => ({
            ...prevData,
            [field]: citationDate(editingValue),
          }));
        } else if (!editingValue) {
          setArticleData((prevData) => ({ ...prevData, [field]: null }));
        }
      } else {
        setArticleData((prevData) => ({ ...prevData, [field]: editingValue }));
      }
    };
    return field === "creators" ? (
      authors.map((author, index) => (
        <div
          onBlur={() =>
            setArticleData((prevData) => ({ ...prevData, creators: authors }))
          }
          key={index}
          className="content-p flex"
        >
          <span className="label">{citationFields[field]}:</span>
          <div className="full-width">
            <input
              type="text"
              placeholder="First Name"
              value={author.firstName}
              onChange={(e) =>
                handleAuthorChange(index, "firstName", e.target.value)
              }
              className={`editable-span author ${
                !author.firstName ? "require" : ""
              }`}
            />
            <input
              type="text"
              placeholder="Last Name"
              value={author.lastName}
              onChange={(e) =>
                handleAuthorChange(index, "lastName", e.target.value)
              }
              className="editable-span"
            />
            <div style={{ width: "10%", display: "flex" }}>
              <AddIcon
                style={{
                  cursor: "pointer",
                }}
                onClick={() => addAuthor(index + 1)}
              />
              <DeleteIcon
                style={{
                  cursor: index === 0 ? "default" : "pointer",
                  color: index === 0 ? "gray" : "inherit",
                  pointerEvents: index === 0 ? "none" : "auto",
                }}
                onClick={() => removeAuthor(index)}
              />
            </div>
          </div>
        </div>
      ))
    ) : (
      <div key={field} className="content-p flex">
        <span className="label">{citationFields[field]}:</span>
        <div className="full-width">
          <input
            type="text"
            className={`editable-span ${required ? "require" : ""}`}
            value={
              editingField === field ? editingValue : renderFieldValue(field)
            }
            onFocus={() => {
              setEditing(field);
              setEditingValue(renderFieldValue(field));
            }}
            onBlur={handleBlur}
            placeholder={
              field === "author"
                ? "Firstname Lastname (use ';' to separate multiple)"
                : ""
            }
            onChange={(e) => handleInputChange(field, e.target.value)}
          />
          {(field === "date" || field === "accessDate") && (
            <Tooltip title="View calendar">
              <CalendarMonthIcon
                style={{ cursor: "pointer" }}
                className="mb-3 mt-2"
                onClick={() => {
                  setCalendarPopup((prev) => !prev);
                  setCurrVal(field);
                }}
              />
            </Tooltip>
          )}
        </div>
      </div>
    );
  };

  const handleSave = () => {
    dispatch(
      setArticleDataCitation({
        ...articleData,
        creators: authors,
        citationMeta: true,
      })
    );
    if (collectionIdid) {
      handleSavedCollection(authors);
    } else {
      setArticleData((prev) => ({ ...prev, creators: authors }));
      handleSaveBookmark();
    }
  };

  const handleSaveBookmark = async () => {
    if (location.pathname.includes("books/")) {
      setBookmarkData((book) => ({ ...book, citationMeta: true }));
      setSaveBookmarkPopup(true);
      return;
    }
    setBookmarkData({
      displayUrl: articleData.url,
      url: articleData.url,
      entityName: summaryInfoData.publisher,
      datePublished: summaryInfoData.published_date,
      citationMeta: true,
    });

    setSaveBookmarkPopup(true);
  };

  const divRef = useRef(null);

  useEffect(() => {
    if (divRef.current) {
      divRef.current.focus();
    }
  }, []);

  useEffect(() => {
    if (currVal === "date") {
      setArticleData((prevData) => ({
        ...prevData,
        date: citationDate(date),
      }));
    } else if (currVal === "accessDate") {
      setArticleData((prevData) => ({
        ...prevData,
        accessDate: citationDate(accessDate),
      }));
    }
  }, [date, accessDate]);

  const transformCreators = (creators) => {
    const transformedCreators = creators.map((creator) => {
      if ("name" in creator) {
        const { name, ...rest } = creator;
        return {
          ...rest,
          firstName: name,
        };
      }
      return creator;
    });
    setAuthors(transformedCreators);
  };

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;

    const fetchData = async () => {
      setLoading(true);

      if (collectionIdid && citationAvailable) {
        fetchIfExistingCitation();
        return;
      }
      let config = {
        method: "post",
        url: citationAPI.getCitationMeta,
        headers: {
          "Content-Type": "text/plain",
        },
        data: url,
        signal,
      };

      try {
        const { data } = await axios.request(config);
        const currentItemType = itemTypes.filter(
          (item) => item.key.toLowerCase() === data[0].itemType.toLowerCase()
        )[0];
        if (data[0].creators.length > 0) {
          transformCreators(data[0].creators);
        } else {
          setAuthors([{ firstName: "", lastName: "", creatorType: "author" }]);
        }
        setCurrentItemType(currentItemType);
        await handleSuccessCitationResponse(data, currentItemType);
      } catch (err) {
        if (axios.isCancel(err)) {
          console.log("Request canceled", err.message);
        } else {
          await handleErrorCitationResponse();
          setError(err.toString());
        }
      } finally {
        setLoading(false);
      }
    };

    if (url && itemTypes.length) {
      setLoading(true);
      handleNull();
      fetchStyles();
      fetchData();
    }
    return () => {
      controller.abort();
    };
  }, [url, itemTypes]);

  useEffect(() => {
    if (getFormattedDate(date) === "Jan 1, 1970") {
      setDate(null);
    }
    if (getFormattedDate(accessDate) === "Jan 1, 1970") {
      setAccessDate(null);
    }
  }, [date]);

  useEffect(() => {
    if (collectionIdid && citationStyles.length && !currentStyle?.name) {
      if (savedStyle) {
        const c = citationStyles
          .filter(
            (style) => style.title.toLowerCase() === savedStyle.toLowerCase()
          )
          .map((fields) => ({
            name: fields.title,
            key: fields.name,
          }));
        !currentStyle?.name && setCurrentStyle(c[0]);
      }
    }
  }, [articleData.styles, citationStyles, savedStyle]);

  const handleDrag = (e, ui) => {
    const { x, y } = ui;
    setPosition((prevPosition) => ({
      ...prevPosition,
      marginTop: y,
      marginLeft: x,
    }));
  };

  return (
    citationPopup && (
      <>
        <div className="popup-citation-bg-dark" />
        {!isMobile ? (
          <Draggable
            position={{ x: position.marginLeft, y: position.marginTop }}
            onDrag={handleDrag}
            cancel={isMobile ? ".popup-citation" : null}
          >
            <div
              // ref={divRef}
              // onKeyDown={(e) => handleKeyDown(e)}
              // tabIndex="0"
              className="popup-citation"
            >
              <div className="popup-card">
                <CloseIcon className="cross" onClick={handleClose} />

                {loading || !options.length ? (
                  <CustomLoader height="20vh" style={true} />
                ) : (
                  <>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "2rem",
                      }}
                    >
                      {citationStyles && (
                        <div className="content-select flex">
                          <span className="label mr-1">Styles:</span>
                          <MenuPrimary
                            data={options?.map((option) => ({
                              ...option,
                              onClick: () => {
                                handleChange(option.name);
                              },
                            }))}
                            children={
                              <div className="flex">
                                <p>{currentStyle?.name}</p>
                                {}
                                <KeyboardArrowDownOutlinedIcon />
                              </div>
                            }
                          />
                        </div>
                      )}
                      {itemTypes && (
                        <div className="content-select flex">
                          <span className="label mr-1">Item Type:</span>
                          <MenuPrimary
                            data={itemTypes?.map((option) => ({
                              ...option,
                              onClick: () => {
                                handleItemChange(option);
                              },
                              key: option.name_chr,
                            }))}
                            children={
                              <div className="flex">
                                <p>{currentItemType?.name}</p>
                                {}
                                <KeyboardArrowDownOutlinedIcon />
                              </div>
                            }
                          />
                        </div>
                      )}
                    </div>
                    <div className="content">
                      <CloseIcon className="cross" onClick={handleClose} />
                      <p className="popup-title">Citation Info</p>
                      {Object.keys(citationFields).map((field) =>
                        renderEditableField(field)
                      )}
                      <p className="email-info-message">
                        **Please double click on the field you want to edit**
                      </p>
                    </div>
                    {citation && (
                      <p className="content-p mb-5">
                        <span className="label">Citation:</span>
                        <span
                          className="editable-span"
                          onClick={() => setEditing("accessed")}
                          onBlur={() => setEditing(null)}
                          dangerouslySetInnerHTML={{ __html: citation }}
                        />
                      </p>
                    )}
                    <div className="save-actions">
                      <div />
                      <div className="flex">
                        <ButtonPrimary
                          text="Cancel"
                          onClick={handleClose}
                          className="mr-2 grey"
                          outline
                        />
                        <Tooltip title={tooltipTitle}>
                          <button
                            id="tooltipButton"
                            className="btn-copy outlined mr-2"
                            onClick={handleCopy}
                            onMouseOut={handleMouseOut}
                          >
                            <p>Copy</p>
                          </button>
                        </Tooltip>
                        <ButtonPrimary
                          text="Save"
                          onClick={handleSave}
                          className={`mr-2 ${citation ? "" : "grey"}`}
                          outline={`${citation ? "" : "true"}`}
                        />{" "}
                        <ButtonPrimary
                          text="Generate"
                          onClick={generateCitationData}
                          className={`${!citation ? "" : "grey"}`}
                          outline={`${!citation ? "" : "true"}`}
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </Draggable>
        ) : (
          <div
            // ref={divRef}
            // onKeyDown={(e) => handleKeyDown(e)}
            // tabIndex="0"
            className="popup-citation"
          >
            <div className="popup-card">
              <CloseIcon className="cross" onClick={handleClose} />

              {loading || !options.length ? (
                <CustomLoader height="20vh" style={true} />
              ) : (
                <>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "2rem",
                    }}
                  >
                    {citationStyles && (
                      <div className="content-select flex">
                        <span className="label mr-1">Styles:</span>
                        <MenuPrimary
                          data={options?.map((option) => ({
                            ...option,
                            onClick: () => {
                              handleChange(option.name);
                            },
                          }))}
                          children={
                            <div className="flex">
                              <p>{currentStyle?.name}</p>
                              {}
                              <KeyboardArrowDownOutlinedIcon />
                            </div>
                          }
                        />
                      </div>
                    )}
                    {itemTypes && (
                      <div className="content-select flex">
                        <span className="label mr-1">Item Type:</span>
                        <MenuPrimary
                          data={itemTypes?.map((option) => ({
                            ...option,
                            onClick: () => {
                              handleItemChange(option);
                            },
                            key: option.name_chr,
                          }))}
                          children={
                            <div className="flex">
                              <p>{currentItemType?.name}</p>
                              {}
                              <KeyboardArrowDownOutlinedIcon />
                            </div>
                          }
                        />
                      </div>
                    )}
                  </div>
                  <div className="content">
                    <CloseIcon className="cross" onClick={handleClose} />
                    <p className="popup-title">Citation Info</p>
                    {Object.keys(citationFields).map((field) =>
                      renderEditableField(field)
                    )}
                    <p className="email-info-message">
                      **Please double click on the field you want to edit**
                    </p>
                  </div>
                  {citation && (
                    <p className="content-p mb-5">
                      <span className="label">Citation:</span>
                      <span
                        className="editable-span"
                        onClick={() => setEditing("accessed")}
                        onBlur={() => setEditing(null)}
                        dangerouslySetInnerHTML={{ __html: citation }}
                      />
                    </p>
                  )}
                  <div className="save-actions">
                    <div />
                    <div className="flex">
                      <ButtonPrimary
                        text="Cancel"
                        onClick={handleClose}
                        className="mr-2 grey"
                        outline
                      />
                      <Tooltip title={tooltipTitle}>
                        <button
                          id="tooltipButton"
                          className="btn-copy outlined mr-2"
                          onClick={handleCopy}
                          onMouseOut={handleMouseOut}
                        >
                          <p>Copy</p>
                        </button>
                      </Tooltip>
                      <ButtonPrimary
                        text="Save"
                        onClick={handleSave}
                        className={`mr-2 ${citation ? "" : "grey"}`}
                        outline={`${citation ? "" : "true"}`}
                      />{" "}
                      <ButtonPrimary
                        text="Generate"
                        onClick={generateCitationData}
                        className={`${!citation ? "" : "grey"}`}
                        outline={`${!citation ? "" : "true"}`}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        )}
        {calendarPopup && (
          <DateComponent
            setCalendarPopup={setCalendarPopup}
            reqDate={
              currVal === "date"
                ? getCitationDate(articleData.date)
                : getCitationDate(articleData.accessDate)
            }
            setDate={currVal === "date" ? setDate : setAccessDate}
            requiredDates={0}
          />
        )}
      </>
    )
  );
};

export default PopupCitation;
